import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from '@mui/material'
import InformationTable from '../../components/Table/InformationTable'
import { dateToString } from '../../utils/date'
import { compareRawDates } from '../../utils/date'
import css from './ModalDetalleAsistencias.module.css'
import EstadoAsistencia from '../../components/EstadoAsistencia/EstadoAsistencia'

const ModalDetalleAsistencias = ({ open, onClose, pack }) => {
  if (!pack) return null

  const asistenciasOrdenadas = [...(pack.asistencias || [])].sort(
    (a, b) =>
      compareRawDates(a.fecha, b.fecha) ||
      (a.hora || '').localeCompare(b.hora || '')
  )

  return (
    <Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle>
        {pack.alumno} - {pack.pack}
      </DialogTitle>
      <DialogContent className={css.main}>
        <InformationTable
          details={[
            { title: 'Centro', key: 'centro', sortDisabled: true },
            { title: 'Fecha', key: 'fecha', sortDisabled: true },
            { title: 'Hora', key: 'hora', sortDisabled: true },
            {
              title: 'Estado',
              key: 'estado',
              align: 'center',
              sortDisabled: true
            },
            { title: 'Asignatura', key: 'asignatura', sortDisabled: true },
            { title: 'Profesor', key: 'profesor', sortDisabled: true }
          ]}
          data={asistenciasOrdenadas.map(asistencia => ({
            centro: asistencia.centro || '--',
            fecha: dateToString(asistencia.fecha),
            hora: asistencia.hora || '--',
            profesor: asistencia.profesor || '--',
            asignatura: asistencia.asignatura || '--',
            estado: <EstadoAsistencia asistencia={asistencia} />
          }))}
        />
      </DialogContent>
      <DialogActions>
        <Button color='error' onClick={onClose}>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalDetalleAsistencias
